import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  Divider,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  InputLabel,
  CardHeader,
  Button,
  Switch
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import { Formik } from 'formik';
import { useAlert } from 'react-alert';
import * as Yup from "yup";
import { KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { LoadingComponent } from 'src/utils/newLoader';
import { useParams } from 'react-router-dom';
import tokenService from '../../../utils/tokenDecoder';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = "ROUTEMANAGERREGISTRATION";

export default function RouteManagerListing() {
  const classes = useStyles();
  const [btnDisable, setBtnDisable] = useState(false);
  const [routeManager, setRouteManager] = useState({
    groupID: '0',
    factoryID: '0',
    titleID: '0',
    genderID: '0',
    firstName: '',
    lastName: '',
    dob: null,
    mobileNumber: null,
    joiningDate: null,
    nic: '',
    routeManagerCode: '',
    routeID: '0',
    secondName: '',
    isActive: true
  });

  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [routes, setRoutes] = useState();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const alert = useAlert();
  let decryptedID = 0;
  const { routeManagerID } = useParams();
  useEffect(() => {
    trackPromise(
      getPermission()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropDown(),
    )
  }, [routeManager.groupID]);

  useEffect(() => {
    if (routeManager.factoryID && routeManager.factoryID !== '0' &&
      routeManager.groupID && routeManager.groupID !== '0') {
      trackPromise(
        getRoutesForDropDown()
      );
    }
  }, [routeManager.factoryID, routeManager.groupID]);

  useEffect(() => {
    if (routeManager.titleID == 1) {
      setRouteManager({
        ...routeManager,
        genderID: 1,
      });
    } else if (routeManager.titleID == 2) {
      setRouteManager({
        ...routeManager,
        genderID: 2,
      });
    } else if (routeManager.titleID == 0) {
      setRouteManager({
        ...routeManager,
        genderID: 0,
      });
    }
  }, [routeManager.titleID]);

  useEffect(() => {
    decryptedID = atob(routeManagerID.toString());
    if (decryptedID != 0) {
      trackPromise(getRouteManagerDetailsFromID(decryptedID));

    }
  }, []);
  async function getRouteManagerDetailsFromID(decryptedID) {
    setIsUpdate(true);
    let response = await services.getRouteManagerDetailsFromID(decryptedID);
    setRouteManager({
      ...response,
      genderID: response.genderID == null ? '0' : response.genderID,
      titleID: response.titleID == null ? '0' : response.titleID,
    });

  }
  async function getRoutesForDropDown() {
    const routes = await services.getRoutesForDropDown(routeManager.factoryID, routeManager.groupID);
    setRoutes(routes);
  }

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITROUTEMANAGERREGISTRATION');

    if (isAuthorized === undefined) {
      navigate('/404');
      return;
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const tokenGroupID = tokenService.getGroupIDFromToken();
    const tokenFactoryID = tokenService.getFactoryIDFromToken();

    setRouteManager(prev => ({
      ...prev,
      groupID: tokenGroupID ? parseInt(tokenGroupID) : '0',
      factoryID: tokenFactoryID ? parseInt(tokenFactoryID) : '0'
    }));

    trackPromise(getGroupsForDropdown());
  }

  async function getFactoriesForDropDown() {
    const factoryList = await services.getFactoryByGroupID(routeManager.groupID);
    setFactories(factoryList);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }



  async function saveRouteManagerGeneral(values) {
    if (isUpdate) {
      let general = {
        titleID: values.titleID == "0" ? null : values.titleID,
        firstName: values.firstName.trim(),
        secondName: values.secondName ? (values.secondName.trim() === '' ? null : values.secondName.trim()) : null,
        lastName: values.lastName.trim(),
        genderID: values.genderID == "0" ? null : values.genderID,
        dob: values.dob == null ? null : moment(values.dob).format('YYYY-MM-DD'),
        nic: values.nic ? (values.nic.trim() === '' ? null : values.nic.trim()) : null,
        mobileNumber: values.mobileNumber ? (values.mobileNumber.trim() === '' ? null : values.mobileNumber.trim()) : null,
        groupID: values.groupID,
        factoryID: values.factoryID,
        routeID: values.routeID,
        joiningDate: moment(values.joiningDate).format('YYYY-MM-DD'),
        routeManagerCode: values.routeManagerCode,
        isActive: values.isActive,
        modifiedBy: tokenService.getUserIDFromToken(),
        modifiedDate: new Date().toISOString(),
        routeManagerID: atob(routeManagerID.toString())
      }
      var response = await services.UpdateRouteManagerDetails(general);
      if (response.statusCode == "Error") {
        alert.error(response.message);
      } else {
        alert.success("Route Manager details updated sucessfully.");
        btnchecking();
        navigate('/app/routeManagerRegistration/listing');
      }
    } else {
      let general = {
        titleID: parseInt(values.titleID) == 0 ? null : parseInt(values.titleID),
        firstName: values.firstName.trim(),
        secondName: values.secondName ? (values.secondName.trim() === '' ? null : values.secondName.trim()) : null,
        lastName: values.lastName.trim(),
        genderID: parseInt(values.genderID) == 0 ? null : parseInt(values.genderID),
        dob: values.dob,
        nic: values.nic ? (values.nic.trim() === '' ? null : values.nic.trim()) : null,
        mobileNumber: values.mobileNumber ? (values.mobileNumber.trim() === '' ? null : values.mobileNumber.trim()) : null,
        groupID: values.groupID,
        factoryID: parseInt(values.factoryID),
        routeID: parseInt(values.routeID),
        isActive: values.isActive,
        routeManagerCode: parseInt(values.routeManagerCode),
        joiningDate: values.joiningDate,
        createdBy: tokenService.getUserIDFromToken(),
        createdDate: new Date().toISOString(),
      }
      var response = await services.saveRouteManagerDetails(general);
      if (response.statusCode == "Error") {
        alert.error(response.message);
      } else {
        alert.success("Route Manager details added.");
        btnchecking();
        navigate('/app/routeManagerRegistration/listing');
      }

    }
  }
  function btnchecking() {
    setBtnDisable(false);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChangeForm(e) {
    const { name, value } = e.target;
    setRouteManager(prev => ({
      ...prev,
      [name]: value
    }));
  }

  function handleDateChange(value, field) {
    setRouteManager(prev => ({
      ...prev,
      [field]: value
    }));
  }
  function handleClick() {
    navigate('/app/routeManagerRegistration/listing');
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={() => handleClick()}
          />
        </Grid>
      </Grid>
    )
  }
  return (
    <Page className={classes.root} title="Route Manager Details Add Edit">
      <Container maxWidth={false}>
        <LoadingComponent />
        <Formik
          initialValues={{
            titleID: routeManager.titleID,
            firstName: routeManager.firstName,
            secondName: routeManager.secondName,
            lastName: routeManager.lastName,
            genderID: routeManager.genderID,
            dob: routeManager.dob,
            groupID: routeManager.groupID,
            factoryID: routeManager.factoryID,
            joiningDate: routeManager.joiningDate,
            mobileNumber: routeManager.mobileNumber,
            nic: routeManager.nic,
            routeManagerCode: routeManager.routeManagerCode,
            routeID: routeManager.routeID,
            isActive: routeManager.isActive
          }}
          validationSchema={
            Yup.object().shape({
              firstName: Yup.string().trim().matches(/^[a-zA-Z]+$/, "Only alphabetic characters without spaces are allowed.").max(50, "First name must be at most 50 characters.").required('First name is required').matches(/^[a-zA-Z]+[a-zA-Z.]+[ (a-zA-Z)+]*$/, "Only alphabetic characters without spaces are allowed."),
              secondName: Yup.string().trim().matches(/^[a-zA-Z]+$/, "Only alphabetic characters without spaces are allowed.").max(50, "First name must be at most 50 characters.").matches(/^[a-zA-Z]+[a-zA-Z.]+[ (a-zA-Z)+]*$/, "Only alphabetic characters without spaces are allowed.").nullable(),
              lastName: Yup.string().trim().matches(/^[a-zA-Z]+$/, "Only alphabetic characters without spaces are allowed.").max(50, "First name must be at most 50 characters.").required('Last name is required').matches(/^[a-zA-Z]+[a-zA-Z.]+[ (a-zA-Z)+]*$/, "Only alphabetic characters without spaces are allowed."),
              joiningDate: Yup.date().required('Joining Date is required').typeError('Joining date is required'),
              mobileNumber: Yup.string().trim().test('is-valid-number', 'Mobile number must be exactly 10 digits and contain only numbers', value => {
                if (!value) return true;
                return /^[0-9]{10}$/.test(value);
              }).nullable(),
              groupID: Yup.number().required('Group required').min("1", 'Select a group'),
              factoryID: Yup.number().required('Factory required').min("1", 'Select a factory'),
              routeManagerCode: Yup.string().required('Route Manager Code is required').matches(/^[0-9\b]+$/, 'Only allow numbers'),
              routeID: Yup.number().required('Route is required').min("1", 'Route is required'),
              nic: Yup.string().trim().test('is-valid-nic', 'NIC must be 9 digits followed by a letter or 12 digits', value => {
                if (!value) return true;
                return /^(\d{9}[vVxX]|\d{12})$/.test(value);
              }).nullable()
            })
          }
          onSubmit={(values) => saveRouteManagerGeneral(values)}
          enableReinitialize
        >
          {({
            errors,
            handleBlur,
            handleSubmit,
            touched
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={3}>
                <Card className={classes.cardContent}>
                  <CardHeader
                    title={
                      !isUpdate ? cardTitle("Add Route Manager") : cardTitle("Update Route Manager")}
                  />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent >
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            size='small'
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.groupID}
                            variant="outlined"
                            id="groupID"
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled ? true : false,
                            }}
                          >
                            <MenuItem value='0'>--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            size='small'
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.factoryID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled ? true : false,
                            }}
                          >
                            <MenuItem value='0'>--Select Operation Entity--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="routeID">
                            Route *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.routeID && errors.routeID)}
                            fullWidth
                            helperText={touched.routeID && errors.routeID}
                            size='small'
                            name="routeID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.routeID}
                            variant="outlined"
                          >
                            <MenuItem value='0'>--Select Route--</MenuItem>
                            {generateDropDownMenu(routes)}
                          </TextField>
                        </Grid>
                      </Grid>
                      <br></br>
                      <Divider />
                      <br></br>
                      <Grid container spacing={3}>

                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="routeManagerCode">
                            Route Manager Code*
                          </InputLabel>
                          <TextField
                            error={Boolean(touched.routeManagerCode && errors.routeManagerCode)}
                            fullWidth
                            helperText={touched.routeManagerCode && errors.routeManagerCode}
                            size='small'
                            name="routeManagerCode"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.routeManagerCode}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="nic">
                            NIC
                          </InputLabel>
                          <TextField
                            error={Boolean(touched.nic && errors.nic)}
                            fullWidth
                            helperText={touched.nic && errors.nic}
                            size='small'
                            name="nic"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.nic}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="titleID">
                            Title
                          </InputLabel>
                          <TextField select fullWidth
                            error={Boolean(touched.titleID && errors.titleID)}
                            helperText={touched.titleID && errors.titleID}
                            size='small'
                            onBlur={handleBlur}
                            id="titleID"
                            name="titleID"
                            value={routeManager.titleID}
                            type="text"
                            variant="outlined"
                            onChange={(e) => handleChangeForm(e)}
                          >
                            <MenuItem value="0">--Select Title--</MenuItem>
                            <MenuItem value="1">Mr</MenuItem>
                            <MenuItem value="2">Ms</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="firstName">
                            First Name *
                          </InputLabel>
                          <TextField
                            error={Boolean(touched.firstName && errors.firstName)}
                            fullWidth
                            helperText={touched.firstName && errors.firstName}
                            size='small'
                            name="firstName"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.firstName}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="secondName">
                            Second Name
                          </InputLabel>
                          <TextField
                            error={Boolean(touched.secondName && errors.secondName)}
                            fullWidth
                            helperText={touched.secondName && errors.secondName}
                            size='small'
                            name="secondName"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.secondName}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="lastName">
                            Last Name *
                          </InputLabel>
                          <TextField
                            error={Boolean(touched.lastName && errors.lastName)}
                            fullWidth
                            helperText={touched.lastName && errors.lastName}
                            size='small'
                            name="lastName"
                            type="lastName"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.lastName}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="genderID">
                            Gender
                          </InputLabel>
                          <TextField select fullWidth
                            error={Boolean(touched.genderID && errors.genderID)}
                            helperText={touched.genderID && errors.genderID}
                            size='small'
                            onBlur={handleBlur}
                            id="genderID"
                            name="genderID"
                            value={
                              routeManager.genderID
                            }
                            type="text"
                            variant="outlined"
                            onChange={(e) => handleChangeForm(e)}>
                            <MenuItem value="0">--Select Gender--</MenuItem>
                            <MenuItem value="1">Male</MenuItem>
                            <MenuItem value="2">Female</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="dob">
                            Date Of Birth
                          </InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              error={Boolean(touched.dob && errors.dob)}
                              helperText={touched.dob && errors.dob}
                              autoOk
                              fullWidth
                              variant="inline"
                              format="dd/MM/yyyy"
                              margin="dense"
                              id="dob"
                              name="dob"
                              value={routeManager.dob}
                              maxDate={new Date()}
                              onChange={(e) => handleDateChange(e, "dob")}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              InputProps={{ readOnly: true }}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="joiningDate">
                            Joining Date *
                          </InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              error={Boolean(touched.joiningDate && errors.joiningDate)}
                              helperText={touched.joiningDate && errors.joiningDate}
                              autoOk
                              fullWidth
                              variant="inline"
                              format="dd/MM/yyyy"
                              margin="dense"
                              id="joiningDate"
                              name="joiningDate"
                              value={routeManager.joiningDate}
                              maxDate={new Date()}
                              onChange={(e) => handleDateChange(e, "joiningDate")}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}


                            />
                          </MuiPickersUtilsProvider>
                        </Grid>

                      </Grid>
                      <br></br>
                      <Divider />
                      <br></br>
                      <Grid container spacing={3}>

                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="mobileNumber">
                            Mobile Number
                          </InputLabel>
                          <TextField
                            error={Boolean(touched.mobileNumber && errors.mobileNumber)}
                            fullWidth
                            helperText={touched.mobileNumber && errors.mobileNumber}
                            size='small'
                            name="mobileNumber"
                            onBlur={handleBlur}
                            onChange={(e) => handleChangeForm(e)}
                            value={routeManager.mobileNumber}
                            variant="outlined"
                          />
                        </Grid>

                      </Grid>
                      <br></br>
                      <Grid container spacing={0}>
                        <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <Switch
                            checked={routeManager.isActive}
                            onChange={() => setRouteManager(prev => ({ ...prev, isActive: !prev.isActive }))}
                            name="isActive"
                            size="medium"
                          />
                          <InputLabel id="isActive" style={{ marginTop: '0.3rem' }}>
                            Active
                          </InputLabel>
                        </Grid>
                      </Grid>

                    </CardContent>
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        color="primary"
                        disabled={btnDisable}
                        type="submit"
                        variant="contained"
                      >
                        {isUpdate ? "Update" : "Add"}
                      </Button>
                    </Box>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
};

